{
  "comments": {
    "comment_form": {
      "placeholder": "Ajouter un commentaire..."
    },
    "comment_thread_count": {
      "comments_count": "{{count}} commentaire",
      "comments_count_plural": "{{count}} commentaires"
    },
    "comment_thread": {
      "show_more": "Afficher plus"
    },
    "comment_thread_slide": {
      "comments": "Commentaires"
    },
    "open_comment_thread_slide_button": {
      "open_comments": "Ouvrir les commentaires"
    }
  },
  "comment_actions": {
    "aria_label": "actions de commentaire"
  },
  "comment_preview": {
    "edited": "Modifié",
    "deleted_message": "Ce commentaire a été supprimé."
  },
  "remove_comment": {
    "confirm_delete_title": "Êtes-vous sûr de vouloir supprimer ce commentaire?",
    "confirm_delete_content": "Cliquez sur confirmer pour supprimer ce commentaire"
  }
}
